/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsLogoList = {
    init: function ($section) {

      // Add settings from schema to current object
      Shopify.theme.jsLogoList = $.extend(this, Shopify.theme.getSectionData($section));
      console.log(this.collection_style,this.mbl_collection_style);
      let $sliderEl = $section.find('[data-slider]');
      let $mblSliderEl = $section.find('[mbl-data-slider]');

      
        this.createSlider($sliderEl);
      
      
   
        
        if(!isScreenSizeLarge()){
          this.createSlider($mblSliderEl);
      }
    },
    createSlider: function ($sliderEl) {

      const slideData = {
        products_per_slide: this.products_per,
        products_available: this.products_available,
        products_limit: this.products_limit,
      }

      const slider = $sliderEl.flickity({
        lazyLoad: 2,
        freeScroll: false,
        imagesLoaded: true,
        draggable: true,
        cellAlign: 'left',
        wrapAround: true,
        pageDots: true,
        contain: true,
        prevNextButtons: false,
        initialIndex: 0,
        arrowShape: arrowShape
      });
      slider.on('settle.flickity', function () {
        slider.flickity('resize');
      });

    },
    unload: function ($section) {
      let $slider = $section.find('.flickity-enabled');
      $slider.flickity('destroy');
    }
  }

  /******/
})()
  ;